import { Controller } from '@stimulus/core';
import { CookieHelper } from '../helpers/cookie-helper';
import LikeController from './like_controller';

export default class UserMenuController extends Controller {
  public signOut() {
    CookieHelper.set(LikeController.LIKE_COOKIE_PATH, []);
  }
}
